import { INITIALIZE_JSON_WIDGETS_DATA } from '../actionTypes';

export const saveJsonWidgetsData = (data) => {
  return {
    type: INITIALIZE_JSON_WIDGETS_DATA,
    data,
  };
};
